import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "phosphor-react";
import NavbarSearch from './NavbarSearch';
import "./navbar.css";
import logo from "../assets/logo/logo_pojok.png";
import envelope from "../assets/logo/envy.png";
import akun from "../assets/logo/account.png";
import bel from "../assets/logo/bell.png";

export const Navbar = () => {
  const handleSearch = (query) => {
    // Lakukan sesuatu dengan query pencarian, seperti filtering atau navigasi ke halaman pencarian
    console.log('Search query:', query);
  };

  return (
    <div className="navbar" style={{ padding: '10px' }}>
      <div className="logo">
      <Link to="/"> 
        <img src={logo} alt="Logo" /> 
        </Link>
      </div>
      <div className="search-bar">
        <NavbarSearch onSearch={handleSearch} />
      </div>
      <div className="links">
      <Link to="/contact">
          <img src={akun} alt="akun" />
        </Link>
        <Link to="/"> 
          <img src={bel} alt="bell" /> 
        </Link>
        <Link to="/contact">
          <img src={envelope} alt="envy" />
        </Link>
        <Link to="/cart">
          <ShoppingCart size={32} />
        </Link>
      </div>
    </div>
  );
};
